export const tokens = {
    zindex: {
        card: 1,
        background: 2,
        interior: 3,
        content: 4,
        shine: 5,
    },
    card: {
        padding: 12,
        width: 390,
        height: 612,
        radius: 12,
        shineAngle: 28,
    },
    interior: {},
    content: {
        gap: {
            default: 20,
            compact: 16,
        },
    },
    credits: {
        wrapper: {
            gap: 10,
        },
        thumbnail: {
            size: {
                default: 36,
                compact: 32,
            },
            radius: 6,
        },
        details: {
            gap: 4,
        },
        title: {
            fontSize: {
                combo: {
                    default: 16,
                    compact: 12,
                },
                solo: {
                    default: 20,
                    compact: 16,
                },
            },
        },
        subtitle: {
            fontSize: {
                default: 14,
                compact: 12,
            },
        },
    },
    hero: {
        zindex: {
            base: 1,
            main: 2,
            header: 3,
            footer: 4,
        },
        interior: {
            padding: 12,
            gap: 8,
        },
    },
    nftAsset: {
        borderWidth: 3,
        radius: 6,
    },
};
